import { usePlatformUpdate } from '@reapitform/hooks'
import { IDocuments } from '@reapitform/dashboard-ui'
import * as yup from 'yup'

export const sendForActionSchema = yup.object({
  linkExpiryHours: yup.string().required('Link expiry is required'),
  iDs: yup.array(yup.string()).required('Document ID is required'),
})

export type TSendForAction = yup.InferType<typeof sendForActionSchema>

export const useSendForAction = () => {
  const path: string = '/api/User/Document/Approve'

  const [sendForAction, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<TSendForAction, IDocuments>({
    path: path,
    method: 'PATCH',
    headers: {},
    errorMessage: 'Failed to send the agreement',
    successMessage: 'Agreement successfully sent',
  })

  return { sendForSigning: sendForAction, returnData, isLoading, isSuccess, isError }
}
